import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../../components/fonts/font-props';

interface EligibilityCheckMiniProps {
    check: {
        level: string | any;
        is_passed: boolean;
    };
}

const EligibilityCheckMini: React.FC<EligibilityCheckMiniProps> = ({ check }) => {
    return (
        <div className="eligibility-check-mini">
            <div className="check-level">
                <FontBody2 
                    color={check.is_passed ? FONT_COLOR.PRIMARY1 : FONT_COLOR.SEMANTIC_DANGER}
                >
                    {typeof check.level === 'string' ? check.level : JSON.stringify(check.level)}
                </FontBody2>
            </div>
        </div>
    );
};

export default EligibilityCheckMini;
